import React, { FC } from 'react';

import {
  ExecutionsSummary as IExecutionSummary,
  ReportAvatarCell,
  ReportDateCell,
  ReportIssueCell,
  ReportLinkCell,
  ReportStatusCell,
  ReportTestCycleCell,
} from '@qality/common-model';
import { DateFormatService } from '@qality/common-service';

import { ExecutionsSummary } from '../executions-summary/ExecutionsSummary';
import ReportAvatarColumn from '../report/report-columns/ReportAvatarColumn';
import ReportBugsColumn from '../report/report-columns/ReportBugsColumn';
import ReportDateColumn from '../report/report-columns/ReportDateColumn';
import ReportExecutionStatus from '../report/report-columns/ReportExecutionStatus';
import ReportIssueColumn from '../report/report-columns/ReportIssueColumn';
import ReportLink from '../report/report-columns/ReportLink';
import ReportTestCycleColumn from '../report/report-columns/ReportTestCycleColumn';

const BODY_COLUMNS_MAPPER = {
  ISSUE: (cell: ReportIssueCell) => ({
    content: <ReportIssueColumn cell={cell} />,
  }),
  TEST_CYCLE: (cell: ReportTestCycleCell) => ({
    content: <ReportTestCycleColumn cell={cell} />,
  }),
  USER_WITH_AVATAR: (cell: ReportAvatarCell) => ({
    content: <ReportAvatarColumn cell={cell} />,
  }),
  DATE: (cell: ReportDateCell) => ({
    content: <ReportDateColumn cell={cell} />,
  }),
  EXECUTION_STATUS: (cell: ReportStatusCell) => ({
    content: <ReportExecutionStatus cell={cell} />,
  }),
  RELATIVE_LINK: (cell: ReportLinkCell) => ({
    content: <ReportLink cell={cell} />,
  }),
  TEST_EXECUTIONS: (executionsSummary: IExecutionSummary) => ({
    content: <ExecutionsSummary executionsSummary={executionsSummary} />,
  }),
  BUG_IDS: (bugIds: Array<number>) => ({
    content: <ReportBugsColumn ids={bugIds} />,
  }),
};

const VALUE_COLUMNS_MAPPER = {
  ISSUE: (cell: ReportIssueCell) => cell.key + ' ' + cell.summary,
  TEST_CYCLE: (cell: ReportTestCycleCell) => (cell?.name ? cell?.name : '-'),
  USER_WITH_AVATAR: (cell: ReportAvatarCell) =>
    cell?.displayName ? cell.displayName : '-',
  DATE: (cell: ReportDateCell) =>
    DateFormatService.formatDate(cell, 'longDateFormat'),
  EXECUTION_STATUS: (cell: ReportStatusCell) => cell?.name,
};

export default {
  getMapper(
    columnNames: Array<{ type: string }>,
    returnComponent = true
  ): { [key: string]: string | FC } {
    const mapper = {};
    columnNames.forEach((column, index) => {
      if (returnComponent) {
        mapper[index] = BODY_COLUMNS_MAPPER[column.type];
      } else {
        mapper[index] = VALUE_COLUMNS_MAPPER[column.type];
      }
    });
    return mapper;
  },
};
